// Amazon locker (ONCA project): nature J on a French parcelshop.
// Single place to adapt if the criterion changes (e.g. nature M with no country condition).
export const AMAZON_LOCKER_NATURE = 'J';
export const AMAZON_LOCKER_COUNTRY = 'FR';

// Natures to send to the API when Amazon lockers must not be offered (e.g. replace flow)
export function excludeAmazonLockerNature(natures, country) {
  if (String(country).toUpperCase() !== AMAZON_LOCKER_COUNTRY) return natures;
  return natures
    .split(',')
    .filter(n => n.trim() !== AMAZON_LOCKER_NATURE)
    .join(',');
}

export function isAmazonLocker(detail) {
  return (
    !!detail &&
    detail.CodeNature === AMAZON_LOCKER_NATURE &&
    (detail.Adresse?.CodePays ?? detail.Adresse?.Pays?.Code) === AMAZON_LOCKER_COUNTRY
  );
}
